import { Component, ElementRef, EventEmitter, OnInit, ViewChild, Output, Input } from '@angular/core';
import { GlobalConstants } from 'src/app/common/constants/global.constant';

@Component({
  selector: 'iposcen-ipos-help-installation-package',
  templateUrl: './ipos-help-installation-package.component.html',
  styleUrls: ['./ipos-help-installation-package.component.scss']
})
export class IposHelpInstallationPackageComponent implements OnInit {
  @ViewChild('installation') install: ElementRef;
  @Output() readonly sideNav = new EventEmitter();
  @Input() sideNavData;
  @ViewChild('windowsUwpSystems') windowsUwpSystems: ElementRef;
  @ViewChild('windowsSystems') windowsSystems: ElementRef;
  isWindowsUwpSystems = true;
  isWindowsSystems = true;
  globalConst = GlobalConstants;
  installationCancelButtonClickedText = GlobalConstants.INSTALLATION_CANCEL_BUTTON_CLICKED_TEXT;

  constructor() { }

  ngOnInit(): void {
    setTimeout(() => {
      this.install.nativeElement.scrollIntoView();
      
    }, 0);
  }
  change(data) {
    if (data === 'windowsUwpSystems') {
      setTimeout(() => {
        this.windowsUwpSystems.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'windowsSystems') {
      setTimeout(() => {
        this.windowsSystems.nativeElement.scrollIntoView();
      }, 0);
    }
  }
  showDescription(data) {    
    if(data === 'windowsUwpSystems'){
      this.isWindowsUwpSystems = !this.isWindowsUwpSystems;
    }else if (data === 'windowsSystems'){
      this.isWindowsSystems = !this.isWindowsSystems;
    }
  }
  navigate(){
    this.sideNav.emit(['createCustomInstallation', '', 'generate']);
  }
}
